import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { LoggingService, Logger } from './logging.service';

@Injectable({ providedIn: 'root' })
export class BackendVersionService {
  private logger: Logger;

  constructor(
    private apiService: ApiService,
    private loggingService: LoggingService,
  ) {
    this.logger = this.loggingService.rootLogger.newLogger('BackendVersionService');
  }

  getVersion(): Observable<string> {
    return this.apiService.send('Get', '/api/version').pipe(
      map((data: { code_version?: string }) => data?.code_version ?? 'unknown'),
      catchError((err) => {
        this.logger.error('Failed to fetch backend version', { errorObject: err });
        return of('unknown');
      }),
    );
  }
}
